<div class="container">
  <div class="container-suppliers">
    <div class="header">
      <h1 class="title">{{'SUPPLIERS' | translate}}</h1>
      <button class="btn btn-outline-primary primary-btn" (click)="setCreatingSupplier()">{{'NEW' | translate}}</button>
    </div>
    <div class="form-card">
      <div class="search-container visually-hidden">
        <input
          type="text"
          placeholder="{{'SEARCH' | translate}}"
          [(ngModel)]="searchString"
          (keyup)="searchSuppliers()"
        />
      </div>
      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>
      <table *ngIf="!loading" class="table table-bordered table-hover">
        <thead>
          <th scope="col" class="table-start">Id</th>
          <th scope="col">{{'NAME' | translate}}</th>
          <th scope="col">{{'DESCRIPTION' | translate}}</th>
          <th *ngIf="(themingService.shopTheming[0]?.shopId === 4 || themingService.shopTheming[0]?.shopId === 10)" scope="col">{{'DOWNLOAD' | translate}}</th>
          <th scope="col">{{'EDIT' | translate}}</th>
          <th scope="col" class="table-end">{{'DELETE' | translate}}</th>
        </thead>
        <tbody>
          <tr *ngFor="let supplier of suppliers">
            <td>{{supplier.supplierId}}</td>
            <td *ngIf="supplier.shopId !== themingService.shopTheming[0].shopId">
              <a [routerLink]="['/suppliers', supplier.supplierId]" routerLinkActive="active">{{ supplier.supplierName }}</a>
            </td>
            <td *ngIf="supplier.shopId === themingService.shopTheming[0].shopId">
              {{ supplier.supplierName }}
            </td>
            <td *ngIf="supplier.shopId !== themingService.shopTheming[0].shopId">{{'LEGACY_SUPPLIER' | translate}}</td>
            <td *ngIf="supplier.shopId === themingService.shopTheming[0].shopId">{{supplier.supplierDescription}}</td>
            <td *ngIf="(themingService.shopTheming[0]?.shopId === 4 || themingService.shopTheming[0]?.shopId === 10)">
              <div class="dropdown">
                <a class="btn primary-btn dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                  {{'DOWNLOAD_FILE' | translate}}
                </a>

                <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                  <li><a class="dropdown-item" (click)="downloadClientsFile('excel',supplier.supplierId)">📊 {{'EXPORT_TO' | translate}} Excel</a></li>
                  <!-- <li><a class="dropdown-item" (click)="downloadClientsFile('json')">📜 {{'EXPORT_TO' | translate}} JSON</a></li>
                  <li><a class="dropdown-item" (click)="downloadClientsFile('csv')">📄 {{'EXPORT_TO' | translate}} CSV</a></li>
                  <li><a class="dropdown-item" (click)="downloadClientsFile('txt')">📑 {{'EXPORT_TO' | translate}} TXT</a></li> -->
                </ul>
              </div>
            </td>
            <td *ngIf="supplier.shopId !== themingService.shopTheming[0].shopId"></td>
            <td *ngIf="supplier.shopId === themingService.shopTheming[0].shopId">
              <button
                class="btn btn-primary primary-btn"
                (click)="setEditingSupplier(supplier.supplierId)"
              >
                {{'EDIT' | translate}}
              </button>
            </td>
            <td *ngIf="supplier.shopId !== themingService.shopTheming[0].shopId"></td>
            <td *ngIf="supplier.shopId === themingService.shopTheming[0].shopId">
              <button
                class="btn btn-primary remove-btn"
                (click)="modalDelete = true;  supplierIdToDelete = supplier.supplierId"
              >
                {{'DELETE' | translate}}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <app-confirmation-modal *ngIf="modalDelete"
  [title]="'CONFIRM_DELETE_SUPPLIER' | translate"
  [message]="'DELETE_SUPPLIER_WARNING' | translate"
  [confirmText]="'DELETE' | translate"
  [cancelText]="'CANCEL' | translate"
  (response)="deleteSupplier($event)">
  </app-confirmation-modal>

  <div class="modal delete-supplier-confirm-modal" id="deleteSupplierModal" tabindex="-1">
    <div class="modal-dialog supplier-modal-dialog" role="document">
      <div class="modal-content supplier-modal-content">
        <div class="modal-body supplier-modal-body">
          <h3 class="text-center">{{'SUCCESS' | translate}}!</h3>
          <p class="text-center">{{ 'SUPPLIER_DELETED_SUCCESS' | translate }}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
